/* tslint:disable */
/* eslint-disable */
/**
 * FMS Run API
 * The FMS Run API description
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


// May contain unused imports in some cases
// @ts-ignore
import type { CreateRunClubEventDistanceDto } from './create-run-club-event-distance-dto';
// May contain unused imports in some cases
// @ts-ignore
import type { CreateRunClubEventPaceGroupDto } from './create-run-club-event-pace-group-dto';

/**
 * 
 * @export
 * @interface CreateRunClubEventDto
 */
export interface CreateRunClubEventDto {
    /**
     * Organization ID
     * @type {string}
     * @memberof CreateRunClubEventDto
     */
    'organizationId': string;
    /**
     * Event title
     * @type {string}
     * @memberof CreateRunClubEventDto
     */
    'title': string;
    /**
     * Event description
     * @type {string}
     * @memberof CreateRunClubEventDto
     */
    'description'?: string;
    /**
     * Cover photo URL
     * @type {string}
     * @memberof CreateRunClubEventDto
     */
    'coverPhotoUrl': string;
    /**
     * Array of additional image URLs
     * @type {Array<string>}
     * @memberof CreateRunClubEventDto
     */
    'imageUrls': Array<string>;
    /**
     * Assembly time in UTC
     * @type {string}
     * @memberof CreateRunClubEventDto
     */
    'assemblyAt': string;
    /**
     * Start time in UTC
     * @type {string}
     * @memberof CreateRunClubEventDto
     */
    'startAt': string;
    /**
     * End time in UTC
     * @type {string}
     * @memberof CreateRunClubEventDto
     */
    'endAt'?: string;
    /**
     * IANA timezone
     * @type {string}
     * @memberof CreateRunClubEventDto
     */
    'timezone': string;
    /**
     * Country code ISO-3166-1 alpha-2
     * @type {string}
     * @memberof CreateRunClubEventDto
     */
    'countryCode': string;
    /**
     * Country name snapshot
     * @type {string}
     * @memberof CreateRunClubEventDto
     */
    'countryName': string;
    /**
     * Province code (PSGC/ISO-3166-2)
     * @type {string}
     * @memberof CreateRunClubEventDto
     */
    'provinceCode': string;
    /**
     * Province name snapshot
     * @type {string}
     * @memberof CreateRunClubEventDto
     */
    'provinceName': string;
    /**
     * City/Municipality code (PSGC)
     * @type {string}
     * @memberof CreateRunClubEventDto
     */
    'cityCode': string;
    /**
     * City/Municipality name snapshot
     * @type {string}
     * @memberof CreateRunClubEventDto
     */
    'cityName': string;
    /**
     * Barangay code (PSGC)
     * @type {string}
     * @memberof CreateRunClubEventDto
     */
    'barangayCode'?: string;
    /**
     * Barangay name snapshot
     * @type {string}
     * @memberof CreateRunClubEventDto
     */
    'barangayName'?: string;
    /**
     * Postal code
     * @type {string}
     * @memberof CreateRunClubEventDto
     */
    'postalCode': string;
    /**
     * Street
     * @type {string}
     * @memberof CreateRunClubEventDto
     */
    'street'?: string;
    /**
     * Landmark
     * @type {string}
     * @memberof CreateRunClubEventDto
     */
    'landmark'?: string;
    /**
     * Latitude
     * @type {number}
     * @memberof CreateRunClubEventDto
     */
    'latitude'?: number;
    /**
     * Longitude
     * @type {number}
     * @memberof CreateRunClubEventDto
     */
    'longitude'?: number;
    /**
     * Place ID reference
     * @type {string}
     * @memberof CreateRunClubEventDto
     */
    'placeId'?: string;
    /**
     * Maximum participants
     * @type {number}
     * @memberof CreateRunClubEventDto
     */
    'maxParticipants'?: number;
    /**
     * Event visibility
     * @type {string}
     * @memberof CreateRunClubEventDto
     */
    'visibility': CreateRunClubEventDtoVisibilityEnum;
    /**
     * Event status
     * @type {string}
     * @memberof CreateRunClubEventDto
     */
    'status': CreateRunClubEventDtoStatusEnum;
    /**
     * Participation fee amount
     * @type {number}
     * @memberof CreateRunClubEventDto
     */
    'feeAmount'?: number;
    /**
     * Event distances
     * @type {Array<CreateRunClubEventDistanceDto>}
     * @memberof CreateRunClubEventDto
     */
    'distances': Array<CreateRunClubEventDistanceDto>;
    /**
     * Event pace groups (each may optionally reference a distance by index)
     * @type {Array<CreateRunClubEventPaceGroupDto>}
     * @memberof CreateRunClubEventDto
     */
    'paceGroups': Array<CreateRunClubEventPaceGroupDto>;
}

export const CreateRunClubEventDtoVisibilityEnum = {
    Public: 'public',
    Unlisted: 'unlisted',
    Private: 'private'
} as const;

export type CreateRunClubEventDtoVisibilityEnum = typeof CreateRunClubEventDtoVisibilityEnum[keyof typeof CreateRunClubEventDtoVisibilityEnum];
export const CreateRunClubEventDtoStatusEnum = {
    Draft: 'draft',
    Published: 'published',
    Cancelled: 'cancelled'
} as const;

export type CreateRunClubEventDtoStatusEnum = typeof CreateRunClubEventDtoStatusEnum[keyof typeof CreateRunClubEventDtoStatusEnum];


